import { ActionCreator } from '@sendoutcards/core'

export const setAppMessage = ActionCreator(
  'SET_APP_MESSAGE',
  (text: string, messageType?: string, timeout?: number) => ({
    text,
    messageType,
    timeout,
  }),
)

export const resetAppMessage = ActionCreator('RESET_APP_MESSAGE')
